import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// native components
import ScrollToAnchorCta from '../../../components/scrollToAnchorCta';
// styles
import { SectionContainerFafaBannerStyled } from './styles';

export default () => {
  return (
    <SectionContainerFafaBannerStyled
      id='fafa-page-get-matched-banner'
      className='js-hide-on-submit'>
      <Row align='center'>
        <Col align='center'>
          <Typography
            align='center'
            component='h1'
            variant='h2'>
            Get matched with a financial advisor in about three minutes.
          </Typography>
          <ScrollToAnchorCta
            id='fafa-page-get-matched-banner-link'
            targetId='search-section-container'
            variant='buttonLinkTertiary'>
            Already working with us&#63;
          </ScrollToAnchorCta>
        </Col>
      </Row>
    </SectionContainerFafaBannerStyled>
  );
};
